export default {
  title: "Payment Methods",
  subtitle: "Manage payment methods and options",
  
  addNew: "Add New Payment Method",
  createPaymentMethod: "Create Payment Method",
  editPaymentMethod: "Edit Payment Method",
  deletePaymentMethod: "Delete Payment Method",
  
  fields: {
    name: "Method Name",
    type: "Payment Type",
    description: "Description",
    isActive: "Active",
    processingFee: "Processing Fee",
    currency: "Currency",
    provider: "Provider",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At",
    percent: "Percentage"
  },
  
  placeholders: {
    name: "Enter payment method name",
    type: "Select payment type",
    description: "Enter description",
    processingFee: "Enter processing fee",
    provider: "Enter provider name",
    percent: "Enter percentage"
  },
  
  messages: {
    createSuccess: "Payment method created successfully",
    createError: "Failed to create payment method",
    updateSuccess: "Payment method updated successfully",
    updateError: "Failed to update payment method",
    deleteSuccess: "Payment method deleted successfully",
    deleteError: "Failed to delete payment method",
    deleteConfirm: "Are you sure you want to delete this payment method?",
    noPaymentMethods: "No payment methods found",
    loadingPaymentMethods: "Loading payment methods...",
    fetchError: "Failed to fetch payment methods"
  },
  
  validation: {
    nameRequired: "Payment method name is required",
    nameMinLength: "Payment method name must be at least 2 characters",
    typeRequired: "Payment type is required",
    processingFeeMin: "Processing fee must be 0 or greater",
    percentRequired: "Percentage is required",
    percentMaxValue: "Percentage cannot exceed 100%",
    fillAllFields: "Please fill in all required fields"
  },
  
  table: {
    name: "Name",
    type: "Type",
    provider: "Provider",
    processingFee: "Fee",
    status: "Status",
    actions: "Actions"
  },
  
  types: {
    creditCard: "Credit Card",
    debitCard: "Debit Card",
    bankTransfer: "Bank Transfer",
    cash: "Cash",
    check: "Check",
    digitalWallet: "Digital Wallet"
  },
  
  statusOptions: {
    active: "Active",
    inactive: "Inactive"
  },
  
  breadcrumbs: {
    paymentMethods: "Payment Methods",
    create: "Create Payment Method",
    edit: "Edit Payment Method",
    view: "View Payment Method"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index"
  }
};
